var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaliableRoutes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 22.3276 9.65773 21.7533C15.1887 16.9237 18 12.7068 18 9 18 3.75066 13.9029.0 9 0 4.09705.0.0 3.75066.0 9 0 12.7068 2.81131 16.9237 8.34227 21.7533L9 22.3276zM9 19.6634C4.30661 15.4335 2 11.8492 2 9 2 4.8966 5.16411 2 9 2 12.8359 2 16 4.8966 16 9 16 11.8492 13.6934 15.4335 9 19.6634zM9 4c2.7614.0 5 2.23858 5 5 0 2.7614-2.2386 5-5 5-2.76142.0-5-2.2386-5-5C4 6.23858 6.23858 4 9 4zM6 9C6 7.34315 7.34315 6 9 6 10.6569 6 12 7.34315 12 9 12 10.6569 10.6569 12 9 12 7.34315 12 6 10.6569 6 9z",
    fill: "url(#paint0_linear_7438_3256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7438_3256",
    x1: -10.35,
    y1: -0.467184,
    x2: -10.35,
    y2: 18.4148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016dff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliableRoutes);
export default __webpack_public_path__ + "static/media/avaliable_routes.9ab20e08.svg";
export { ForwardRef as ReactComponent };